import { Avatar } from 'antd';
import styles from './LentaItem.module.css'
import { ActivityType, EmogiCount, ImagesDomain } from '../../../../models/commonModels';
import arrowRight from './../../../../image/ic_arrow_right.svg'
import { ReactionPreview } from '../ReactionPreview/ReactionPreview';
import { ImageGroupPreview } from './ImageGroupPreview';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../hooks/redux';
import { setProfileId } from '../../../../store/app-slice/AppSlice';
import { IcRun } from '../../../../components/ActivityBar/images/IcRun';
import { IcBicycle } from '../../../../components/ActivityBar/images/icBicycle';
import { IcSki } from '../../../../components/ActivityBar/images/IcSki';
import { IcSwimming } from '../../../../components/ActivityBar/images/IcSwimming';
import { IcWalk } from '../../../../components/ActivityBar/images/icWalk';
export const LentaItem = (
    {
        name, 
        image, 
        time,distance, 
        distance_day, 
        onCommentClick=f=>f,
        commentButtonDisplay=true,
        reactions,
        contComment,
        photo,
        uId,
        act_type
    }
    :
    {
        name:string, 
        image:ImagesDomain[],
        time:string,
        distance:number,
        distance_day:number,
        onCommentClick?:(x:number,y:number)=>void,
        commentButtonDisplay?:boolean,
        reactions:EmogiCount[],
        contComment:number,
        photo:string|null,
        uId:number,
        act_type:ActivityType
    })=>{

const navigation = useNavigate();
const dispatch:any = useAppDispatch();
const comment_click=(x:number,y:number)=>{
    console.log('click', "x=" + x + "y="+y)
    onCommentClick(x,y)
}

const getActivityImage = () =>{
    switch(act_type){
        case ActivityType.RUN:
            return <IcRun color='green'/>
            break;        
        case ActivityType.BICYCLE:
            return <IcBicycle color='green'/>
            break;  
        case ActivityType.SKIS:
            return <IcSki color='green'/>
            break;  
        case ActivityType.SWIMMING:
            return <IcSwimming color='green'/>
            break;
        case ActivityType.WALK:
            return <IcWalk color='green'/>
            break;              
    }
}

const getDistanceUnit=():string=>{
    switch(act_type){
        case ActivityType.SWIMMING:
            return " м"
            break;
        default:
            return " км"
            break
    }
}
    return(
        <div className={styles.lenta_item}>
            <Avatar size={32} icon={<img src={"https://sportsrestaurant.online"+photo}/>} 
            onClick={()=>{dispatch(setProfileId(uId))
                navigation('/profileId')}}/>
            <div className={styles.lenta_card}>
                <div style={{display:"flex", marginBottom:"5px", gap:"8px"}}>
                    {/* <div className={styles.lenta_text}>{time}</div> */}
                    <div className={styles.lenta_text}>{name}</div>
                    <div className={styles.lenta_text_distance}>{distance + getDistanceUnit()}</div>
                    <div className={styles.lenta_text_distance_day}>{distance_day + " км"}</div>

                </div>
                    {/* {image.map((item)=> <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", maxHeight:"220px", overflow:"hidden"}}>
                        <Image src={"https://sportsrestaurant.online/stored/images/"+item.id}/>
                    </div>)} */}
                    <div style={{maxHeight:"220px", overflow:"hidden"}}>
                        <div style={{position:"relative"}}>
                            <div className={styles.lenta_item_activity_container}>
                                {getActivityImage()}
                            </div>
                             <ImageGroupPreview images={image.map((item)=>{return "https://sportsrestaurant.online/stored/images/"+item.id})}/>
                        </div>
                       
                    </div>
                    
                    {commentButtonDisplay&&
                    <div>
                        {reactions.length>0&&<ReactionPreview reactions={reactions}/>}
                        <div onClick={e=>comment_click(e.pageX, e.pageY)}>
                            <div style={
                                {display:"flex", 
                                flexDirection:"row", 
                                color:"black", 
                                justifyContent:"space-between", 
                                alignItems:"center", 
                                marginTop:"10px",
                                cursor:"pointer"}}>
                                {contComment===0&&<div>Комментировать</div>}
                                {contComment>0&&<div>{contComment +" " + getNoun(contComment, 'комментарий', 'комментария', 'комментариев')}</div>}
                                <img src={arrowRight}/>
                            </div>
                        </div>
                    </div>
                    }
            </div>
        </div>
    )
}

function getNoun(number:number, one:string, two:string, five:string) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
      return five;
    }
    n %= 10;
    if (n === 1) {
      return one;
    }
    if (n >= 2 && n <= 4) {
      return two;
    }
    return five;
  }